// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xFAun","content":"styles_content___ba0f"};